import React, { useState } from 'react';
import { Container } from 'reactstrap';
import { getNews } from '../shared/news/news';
import { Link } from 'react-router-dom';
import PageMeta from './PageMeta';
import '../App.css';
import PagePagination from './PagePagination';
import ChangelogArticle from './news/ChangelogArticle';
import TwitterContainer from './TwitterComponent';

const ARCHIVE_PER_PAGE = 24;

export default function News () {
    //Obtain Articles
    const newsTopics = getNews().sort((a, b) => b.id - a.id);

    //First Article
    const theNews = newsTopics[0];

    return (
        <Container className="gs-page">
            <PageMeta
                title="Changelogs"
                description="Grand Summoners changelog updates for new units, equipment, and dream awakenings in Global and JP."
                path="/news"
            />
            <div className="gs-page-gutter">
                <header className="gs-page-intro">
                    <h1>Changelogs</h1>
                    <p>Website updates, mainly focused on the newest Units & Equips added to Grand Summoners in Global and JP.</p>
                </header>

                <div className="gs-news-layout">
                    <div className="gs-news-layout__main">
                        <ChangelogArticle
                            date={theNews.date}
                            intro={theNews.article.intro}
                            newUnits={theNews.article.new?.units}
                            newEquips={theNews.article.new?.equips}
                            newDream={theNews.article.new?.dream}
                            globalUnits={theNews.article.globalUpdate?.units}
                            globalEquips={theNews.article.globalUpdate?.equips}
                            globalDream={theNews.article.globalUpdate?.dream}
                        />
                    </div>
                    <aside className="gs-news-layout__aside">
                        <TwitterContainer />
                    </aside>
                </div>

                <NewsArchive entries={newsTopics.slice(1)} />
            </div>
        </Container>
    )
}

function NewsArchive({ entries }) {
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.max(1, Math.ceil(entries.length / ARCHIVE_PER_PAGE));
    const safePage = Math.min(Math.max(1, currentPage), totalPages);
    const start = (safePage - 1) * ARCHIVE_PER_PAGE;
    const pageEntries = entries.slice(start, start + ARCHIVE_PER_PAGE);

    if (entries.length === 0) {
        return null;
    }

    return (
        <section className="gs-news-archive-section" aria-label="Changelog archive">
            <h2 className="gs-news-archive__heading">Older changelogs</h2>
            <div className="gs-news-archive">
                {pageEntries.map((entry) => (
                    <Link
                        key={entry.id || entry.date}
                        to={`/news/${entry.date}`}
                        className="gs-news-archive__item"
                    >
                        {entry.date}
                    </Link>
                ))}
            </div>
            <PagePagination
                currentPage={safePage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
                ariaLabel="Changelog archive pages"
                showMeta={false}
            />
        </section>
    )
}
